import React from "react";
import {
  Paper,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

/**
 * CustomizableWidgets
 * Widget for toggling dashboard widgets on/off.
 * Props:
 *   widgets: Array<{ key, label, enabled }>
 *   onToggle: (key: string) => void
 */
export default function CustomizableWidgets({
  widgets = [],
  onToggle = () => {},
}) {
  return (
    <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" fontWeight={700} mb={1}>
        Customize Dashboard
      </Typography>
      <FormGroup>
        {widgets.map((w) => (
          <FormControlLabel
            key={w.key}
            control={
              <Checkbox checked={w.enabled} onChange={() => onToggle(w.key)} />
            }
            label={w.label}
          />
        ))}
      </FormGroup>
    </Paper>
  );
}
